import { ExternalVideoType } from "../../../types"
import { VideoLinks } from "../../constants"
import BBModal from "../modal"

interface Props {
  show: boolean
  videoType: ExternalVideoType
  toggleModal: (show: boolean) => void
  autoPlay?: boolean
}

const HowItWorksModal = ({
  show,
  videoType,
  toggleModal,
  autoPlay = true
}: Props) => {
  const { title, link } = VideoLinks[videoType]

  const onClose = () => {
    toggleModal(false)
  }

  if (!link) return null

  const videoLink =
    link + "?videoFoam=true" + (autoPlay ? "&autoPlay=true" : "")

  return (
    <BBModal show={show} onClose={onClose} title={title} size="2xl">
      <div className="max-w-full">
        <iframe
          title="Learn how it works"
          src={videoLink}
          allowTransparency
          frameBorder={0}
          scrolling="no"
          className="wistia_embed max-w-full"
          name="wistia_embed"
          allowFullScreen
          allow="autoplay; fullscreen"
          width="640"
          height="360"
        ></iframe>
      </div>
    </BBModal>
  )
}

export default HowItWorksModal
